import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateReportsData } from '../reduxstore/actions'
import { fetchfareports, fetchBmReports } from '../services/fetchreport'
import LoaderComponent from '../loaderComp/LoaderComponent'
import ModalComponent from '../ModalComponent/ModalComponent'
import TableComponent from '../tableComponent/TableComponent'
const FavoritesIcon = new URL('../Favorites.svg', import.meta.url).href
const ClockIcon = new URL('../ClockIcon.svg', import.meta.url).href
import './BookmarkComponent.scss'

export default function BookmarkComponent(props: any) {
  const dispatch = useDispatch()
  const userDataFromStore = useSelector((state: any) => state.reducers.userInfo || [])
  const [userData, setuser] = useState<any[]>([])
  const [reports, setreports] = useState<any[]>([])
  const [isDelete, setDelete] = useState(false)
  const [isloading, setLoading] = useState(false)
  const [noReports, setNoReports] = useState(false)
  const [hasError, setError] = useState(false)
  const [modalOpen, setModal] = useState(false)
  const [ModalType, setModalType] = useState('')
  const [modalContent, setModalContent] = useState<any>({
    bookmarkmodal: {
      headerTitle: 'Favorites Reports',
      bodyErrorContent: 'Unable to retrieve bookmarked reports. please try again'
    },
    faReportsmodal: {
      headerTitle: 'Frequently Accessed Reports',
      bodyErrorContent: 'No Frequently Accessed Reports Found.'
    },
    faReportsErrormodal: {
      headerTitle: 'Frequently Accessed Reports',
      bodyErrorContent: 'No Frequently Accessed Reports Found.'
    }
  })
  useEffect(() => {
    if (userDataFromStore.length > 0) {
      setuser(userDataFromStore)
    }
  }, [userDataFromStore])

  const handleModalClose = () => {
    setModal(false)
  }

  const favReportData = async (product?: string) => {
    setModalType('faReportsmodal')
    const user = userData[0]
    if (user) {
      let internalUser = false
      if (user.userType.indexOf('Internal') > -1) {
        internalUser = true
      }
      console.log('favReportData internalUser', internalUser)
      setLoading(true)
      try {
        const userDetails = {
          customerName: [user.customerName],
          reportName: 'string',
          reportNameDt: 'string',
          userRole: 'string',
          userType: user.userType,
          username: user.userName,
          userEmailAddr: user.userEmailAddr,
          encUserType: user.encUserType,
          encUserName: user.encUserName,
          encCustomerName: [user.encCustomerName],
          encUserEmailAddr: user.encUserEmailAddr,
          e_id: user.e_id

        }
        const reportsdataRes: any = await fetchfareports(userDetails)
        setLoading(false)
        const reportsdata = reportsdataRes
        if (reportsdata.status === 404 || reportsdata.status === 400 || reportsdata.status === 204) {
          setNoReports(true)
          setError(true)
          setModalContent({ ...modalContent, faReportsmodal: { headerTitle: 'Frequently Accessed Reports', bodyContent: <div id='faerror'> No Frequently Accessed Reports Found.</div> } })
          setModal(true)
        } else if (reportsdata.ok !== undefined && !reportsdata.ok) {
          setNoReports(true)
          setError(true)
          setModalContent({ ...modalContent, faReportsmodal: { headerTitle: 'Frequently Accessed Reports', bodyContent: <div id='faerror'> No Frequently Accessed Reports Found.</div> } })
          setModal(true)
        } else {
          const modifiedreports: any[] = []
          reportsdata.map((rep: any) => {
            const record: any = {}
            record.id = rep.cust_file_id || rep.cust_file_int_id
            if (user.userType.indexOf('Internal') > -1) {
              record.customerName = rep.customerName
            }
            record.reportName = rep.reportName
            record.reportType = rep.reportTypeDesc ? rep.reportTypeDesc : ''
            record.frequency = rep.reportFrequency
            record.updatedDate = rep.reportGenDate ? rep.reportGenDate : ''
            record.action = 'default'
            record.userTypeName = rep.userTypeName ? rep.userTypeName : ''
            record.reportId = rep.reportId ? rep.reportId : ''
            modifiedreports.push(record)
            return rep
          })
          setreports(modifiedreports)
          setError(false)
          setModalContent({ ...modalContent, faReportsmodal: { headerTitle: 'Frequently Accessed Reports', bodyContent: <TableComponent data={modifiedreports} columnNames={Object.keys(modifiedreports[0])} class={internalUser ? 'Favoriteshistory-table' : 'Favoriteshistory-Ext-table'} rowperpage={5} em={userDetails.encUserEmailAddr} e_id={userDetails.e_id}/>, bodyErrorContent: <div id='faerror'> No Frequently Accessed Reports Found.</div> } })
          setModal(true)
          setDelete(false)
          setError(false)
        }
      } catch (e) {
        setLoading(false)
        console.log(e)
        setNoReports(true)
        setError(true)
        setModalContent({ ...modalContent, faReportsmodal: { headerTitle: 'Frequently Accessed Reports', bodyContent: <div id='faerror'> No Frequently Accessed Reports Found.</div> } })
        setModal(true)
      }
    } else {
      setreports([])
    }
  }

  const bookmarkReportData = async (product?: string) => {
    setModalType('bookmarkmodal')
    const user = userData[0]
    if (user) {
      let internalUser = false
      if (user.userType.indexOf('Internal') > -1) {
        internalUser = true
      }
      setLoading(true)
      try {
        const userDetails = {
          customerName: [user.customerName],
          reportName: 'string',
          reportNameDt: 'string',
          userRole: 'string',
          userType: user.userType,
          username: user.userName,
          userEmailAddr: user.userEmailAddr,
          encUserType: user.encUserType,
          encUserName: user.encUserName,
          encCustomerName: [user.encCustomerName],
          encUserEmailAddr: user.encUserEmailAddr,
          e_id: user.e_id

        }
        const reportsdataRes: any = await fetchBmReports(userDetails)
        setLoading(false)
        const reportsdata = (reportsdataRes || []).filter((rep: any) => (rep.bookmarkStatus ? rep.bookmarkStatus : rep.bookmarkStatus))
        if (reportsdata.status === 404 || reportsdata.status === 400 || reportsdata.status === 204) {
          setNoReports(true)
          setError(false)
          setModalContent({ ...modalContent, bookmarkmodal: { headerTitle: 'Favorites Reports ', bodyContent: <div id='faerror'> No Favorites Reports Found.</div>, bodyErrorContent: <div id='faerror'> No Favorites Reports Found.</div> } })
          setModal(true)
        } else if (reportsdata.ok !== undefined && !reportsdata.ok) {
          setNoReports(true)
          setError(true)
          setModalContent({ ...modalContent, bookmarkmodal: { headerTitle: 'Favorites Reports ', bodyContent: <div id='faerror'> No Favorites Reports Found.</div>, bodyErrorContent: <div id='faerror'> No Favorites Reports Found.</div> } })
          setModal(true)
        } else {
          const modifiedreports: any[] = []
          reportsdata.map((rep: any) => {
            const record: any = {}
            record.id = rep.cust_file_id || rep.cust_file_int_id
            if (user.userType.indexOf('Internal') > -1) {
              record.customerName = rep.customerName
            }
            record.reportName = rep.reportName
            record.reportType = rep.reportTypeDesc ? rep.reportTypeDesc : ''
            record.frequency = rep.reportFrequency
            record.updatedDate = rep.reportGenDate ? rep.reportGenDate : ''
            record.action = 'default'
            record.userTypeName = rep.userTypeName ? rep.userTypeName : ''
            record.reportId = rep.reportId ? rep.reportId : ''
            record.bookmark = 'RemoveBM'
            modifiedreports.push(record)
            return rep
          })
          setreports(modifiedreports)
          setError(false)
          setModalContent({ ...modalContent, bookmarkmodal: { headerTitle: 'Favorites Reports ', bodyContent: <TableComponent data={modifiedreports} columnNames={Object.keys(modifiedreports[0])} class={internalUser ? 'Favoriteshistory-table' : 'Favoriteshistory-Ext-table'} rowperpage={5} em={userDetails.encUserEmailAddr} e_id={userDetails.e_id}/>, bodyErrorContent: <div id='faerror'> No Favorites Reports Found.</div> } })
          setModal(true)
          setDelete(false)
          setError(false)
        }
      } catch (e) {
        setLoading(false)
        console.log(e)
        setNoReports(true)
        setError(false)
        setModalContent({ ...modalContent, bookmarkmodal: { headerTitle: 'Favorites Reports ', bodyContent: <div id='faerror'> No Favorites Reports Found.</div> } })
        setModal(true)
      }
    } else {
      setreports([])
    }
  }
  return (
    <div>
        {isloading && <LoaderComponent />}
        {<div id="mySidenav" >
          <div className='row'>
              <a href="." id="fav" onClick={(e) => { e.preventDefault(); favReportData() }} title="Frequently Accessed Reports">
                <div className='column left'>
                  <span id="sidenavtext">Frequently Accessed</span>
                </div>
                <div className='column right'>
                  <img src={ClockIcon} alt="Frequently Accessed" style={{ width: '20px', height: '20px' }} />
                </div>
              </a>
            </div>
            <div className='row'>
              <a href="." id="bookmark" onClick={(e) => { e.preventDefault(); bookmarkReportData() }} title="Favorites Reports">
                <div className='column left'>
                  <span id="sidenavtext"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Favorites</span>
                </div>
                <div className='column right'>
                  <img src={FavoritesIcon} alt="Favorites" style={{ width: '20px', height: '20px' }} />
                </div>
              </a>
            </div>
        </div>}
        {modalOpen && <ModalComponent isOpen={modalOpen} isDelete={isDelete}onClose={handleModalClose} title={modalContent[ModalType].headerTitle}>
        {hasError ? modalContent[ModalType].bodyContent : modalContent[ModalType].bodyContent}
        <button id="btnReportSearch" data-index={props.index} onClick={handleModalClose} data-id="button-data-id" aria-label="search" role="button" aria-disabled="true" aria-invalid="false" tabIndex={-1} className="primary-button" name="search" type="button" title="" value="search">
                                                        <div>
                                                        {isloading && <LoaderComponent />}
                                                            Close
                                                        </div>
                                                    </button>
        </ModalComponent>}
    </div>
  )
}
